export const getValuesByKeys = (obj, keys) => {
  return keys.map((key) => obj[key]).filter((value) => value !== undefined);
};
